<mat-form-field class="picker-selection">
    <mat-select placeholder="{{title}}" [formControl]="formControl">
      <mat-option (click)="pickChoice(choice.key)"
        *ngFor="let choice of choices" 
        [value]="choice.key">{{choice.value}}</mat-option>
    </mat-select>  
</mat-form-field>